import { render, staticRenderFns } from "./tiktokOrder.vue?vue&type=template&id=6b39d086&scoped=true"
import script from "./tiktokOrder.vue?vue&type=script&lang=js"
export * from "./tiktokOrder.vue?vue&type=script&lang=js"
import style0 from "./tiktokOrder.vue?vue&type=style&index=0&id=6b39d086&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b39d086",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Prod-五域创客/jh-5eck-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6b39d086')) {
      api.createRecord('6b39d086', component.options)
    } else {
      api.reload('6b39d086', component.options)
    }
    module.hot.accept("./tiktokOrder.vue?vue&type=template&id=6b39d086&scoped=true", function () {
      api.rerender('6b39d086', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/orderBox/tiktokOrder.vue"
export default component.exports